import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';

// Hook pour récupérer les pièces
export const usePieces = (filters?: any) => {
  return useQuery({
    queryKey: ['pieces', filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters?.search) params.append('search', filters.search);
      if (filters?.batimentId) params.append('batimentId', filters.batimentId);
      if (filters?.siteId) params.append('siteId', filters.siteId);
      
      const response = await apiClient.get(`/pieces?${params.toString()}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};

// Hook pour créer une pièce
export const useCreatePiece = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: any) => {
      const response = await apiClient.post('/pieces', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pieces'] });
      queryClient.invalidateQueries({ queryKey: ['batiments'] });
    },
  });
};

// Hook pour mettre à jour une pièce
export const useUpdatePiece = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const response = await apiClient.patch(`/pieces/${id}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pieces'] });
      queryClient.invalidateQueries({ queryKey: ['batiments'] });
    },
  });
};

// Hook pour supprimer une pièce
export const useDeletePiece = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/pieces/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pieces'] });
      queryClient.invalidateQueries({ queryKey: ['batiments'] });
    },
  });
};